module.exports = __webpack_public_path__ + "media/images/admin/icons/user-check-119953392d1d73762c71c5e15205a601.svg";